// Global toggle state for the docs pane. Two consumers:
//   1. ModuleDocButton — the floating 📖 icon toggles it.
//   2. App.tsx / ModuleDocPane — reads whether to render the pane column.
//
// Persisted in localStorage so the pane state survives a reload. Simple
// pub/sub because both consumers live in different React subtrees and we
// don't want to route this through the main app store (it's purely UI).

const STORAGE_KEY = "lens_docs_pane_open";
const listeners = new Set<() => void>();

function read(): boolean {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

function write(value: boolean) {
  localStorage.setItem(STORAGE_KEY, String(value));
  for (const l of listeners) l();
}

export function isDocsPaneOpen(): boolean {
  return read();
}

export function toggleDocsPane(): void {
  write(!read());
}

export function setDocsPaneOpen(value: boolean): void {
  write(value);
}

export function subscribeDocsPane(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
